import { oc } from "@orpc/contract";
import type { Session } from "@packages/core/session/session.ts";
import { LanguageIds } from "@packages/core/language/language.ts";
import { Features } from "@packages/core/session/features.ts";
import type { ZodType } from "zod";
import { z } from "zod";

const SessionSchema = z.object({
    memberId: z.string(),
    organizationId: z.string(),
    email: z.string(),
    firstName: z.string().optional(),
    displayName: z.string().optional(),
    preferredLanguage: z.enum(LanguageIds).optional(),
    assignedProducts: z.array(z.string()),
    isOrganizationAdmin: z.boolean(),
    isReportingManager: z.boolean(),
    isTeamManager: z.boolean(),
    isExecutive: z.boolean(),
    isCollaborator: z.boolean(),
    executiveAssignations: z.array(z.string()),
    collaboratorAssignations: z.array(z.string()),
    image: z.string().optional(),
    timeZone: z.string().optional(),
    organizationName: z.string().optional(),
    organizationImage: z.string().optional(),
    hasAccessToWorkleapNext: z.boolean().optional(),
    isInWorkleapNextPreview: z.boolean().optional(),
    jobTitle: z.string().optional(),
    assignedFeatures: z.array(z.enum(Features)).optional()
}) satisfies ZodType<Session>;

export const authContract = {
    me: oc.route({ method: "GET", path: "/me" }).output(SessionSchema.extend({ intercomIdentityToken: z.string().optional() }))
};
